export const loginRoute = '/login';

export const loggedInRoute = '';

export const notFoundRoute = '/404';
